export default __webpack_public_path__ + "static/ne_icin_biriktiriyorsun-3a62f81a9efb9921372c62632672d9b2.svg";